import {Redirect} from 'expo-router';

/*
        // Fixme: should this live here?
        Notifications.setNotificationHandler({
            handleNotification: async () => ({
                shouldPlaySound: true,
                shouldSetBadge: true,
                shouldShowAlert: false, // deprecated
                shouldShowBanner: true,
                shouldShowList: true,
            }),
        });

 */

export default function Index() {
    return <Redirect href="/e"/>;
}